import { Deserializable } from '../protocols/deserializable';

export class MemberSubmissionAccount implements Deserializable {
  public accountId!: number;
  public employerName!: string;
  public governingJurisdiction!: string;
  // Only present for Monthly Pension affected accounts
  public annuityType?: string;
  public annuityGuaranteePeriod?: string;

  public onDeserialize(): void {}
}
